export default __webpack_public_path__ + "static/media/car_1.9f22eee6.png";